import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Lozenge from '@atlaskit/lozenge';
import Tabs, { TabList, TabPanel, useTab } from '@atlaskit/tabs';
import React from 'react';
import { HorizontalScrollShadow, StyledLozenge, TabListContainer } from './ResponsiveTabs.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Tab = _ref => {
  let {
    children,
    testId
  } = _ref;
  const tabAttributes = useTab();
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, tabAttributes), {}, {
    "data-testid": testId,
    children: children
  }));
};
const TabLozenge = _ref2 => {
  let {
    appearance,
    label
  } = _ref2;
  return /*#__PURE__*/_jsx(StyledLozenge, {
    children: /*#__PURE__*/_jsx(Lozenge, {
      appearance: appearance,
      children: label
    })
  });
};

/**
 * A wrapper over Atlaskit tabs that allows additional tabs to
 * be horizontally scrollable if the screen size is too small.
 *
 */
export default function ResponsiveTabs(props) {
  const openTabs = props.tabs;
  const selectedTabIndex = typeof props.selected === 'number' ? props.selected : props.tabs.findIndex(tab => tab.key === props.selected);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props === null || props === void 0 ? void 0 : props.afterTabs, /*#__PURE__*/_jsx(HorizontalScrollShadow, {}), /*#__PURE__*/_jsxs(Tabs, {
      id: props.id,
      testId: props.testId,
      selected: selectedTabIndex,
      onChange: tabIndex => props.onChange(props.tabs[tabIndex]),
      children: [/*#__PURE__*/_jsx(TabListContainer, {
        showAetherAppListingPage: props.showAetherAppListingPage,
        children: /*#__PURE__*/_jsx(TabList, {
          children: openTabs.map(tab => /*#__PURE__*/_jsxs(Tab, {
            testId: tab.testId,
            children: [tab.label, !!tab.lozenge && /*#__PURE__*/_jsx(TabLozenge, _objectSpread({}, tab.lozenge))]
          }, tab.key))
        })
      }), props.tabs.map(tab => /*#__PURE__*/_jsx(TabPanel, {
        children: tab.content
      }, tab.key))]
    })]
  });
}